import React, { useEffect } from 'react'
import { buildGroupsKeyValueArray, getGroupsKeyIndex } from './DocSCFunctions'
import DocSearchGroupRow from './DocSearchGroupRow';
import SarasMenu from '../../../../library/repeater/menu/SarasMenu';
import { Icon } from '../../../../library/decor/SarasIcons';

const DocSearchGroups = (props) => {
    const { viewData, previousGroupKey, onSearchGroupChange } = props;
    const [groupList, setGroupList] = React.useState([]);
    const [currentGroupKey, setCurrentGroupKey] = React.useState({key: previousGroupKey, menuIndex: null});

    // console.log("test", groupList);
    
    //execute whenever field dt changes - effectively this also will run only once
    const initialiseOnDataChange = () => {
        //get the fields list key value pair for the given field dt
        let groupsKeyVal = buildGroupsKeyValueArray(viewData);
        setGroupList(groupsKeyVal.list);

        //set default only when there is no other group selected
        if(currentGroupKey.menuIndex === null
            || currentGroupKey.menuIndex === undefined
            || currentGroupKey.key !== (previousGroupKey || groupsKeyVal.defaultKey)){

            let newKey = {key: null, menuIndex: null};

            if(previousGroupKey && viewData[previousGroupKey])
            {
                newKey = {key: previousGroupKey, menuIndex: null};
            }
            else
            {
                newKey = {key: groupsKeyVal.defaultKey, menuIndex: null};
            }

            //get the menu index
            let keyIndex = getGroupsKeyIndex(groupsKeyVal.list, newKey.key);

            newKey.menuIndex = keyIndex;

            setCurrentGroupKey(newKey);
        }

        // console.log("search groups", groupsKeyVal);
    }

    //execute whenever field dt changes - effectively this also will run only once
    useEffect(initialiseOnDataChange, [viewData, previousGroupKey]);

    const onGroupSelect = (e, index) => {
        let groupRowClicked = groupList[index];
        if (!groupRowClicked) return;
        
        // console.log("fav row object", favRowClicked, favList);
        setCurrentGroupKey({key: groupRowClicked.key, menuIndex: index});

        //fire search request
        if(onSearchGroupChange) onSearchGroupChange(groupRowClicked.key);
    }

    const renderGroupTrigger = () => {
        let DropdownIcon = Icon['arrowmenu'];

        // console.log("error in group", currentGroupKey, viewData, groupList);

        return (
            <span className='uiActionWithMenu uiFlexBox3 uiHover'>
                {`${currentGroupKey && viewData[currentGroupKey.key].dataList.label}`}<DropdownIcon className='uiBrandColor1'/>
            </span>
        )
    }

    if(!groupList || groupList.length === 0){
        return null;
    }
    else {
        return (
            <>
                <SarasMenu 
                    menuTrigger={renderGroupTrigger()} 
                    dataList={groupList} 
                    initialSelectedIndex={currentGroupKey.menuIndex}
                    trackSelection={true}
                    menuListClass="uiStyledMenuItemLabel"
                    menuContainerClass="uiInLine"
                    menuItem={DocSearchGroupRow} onSelection={onGroupSelect}
                    contentStyle={{width:"250px",maxHeight:"400px",overflowY:"scroll"}}
                >
                </SarasMenu>
            </>
        )
    }
}

export default DocSearchGroups;